import { Timer3Icon } from './Timer3Icon';

/**
 * author: Google
 * id 3DEFEFB6-57CE-4C82-9D0C-16DBDBEF5950
 * name timer-3
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-3.svg
 * tags
 * - Date / Time 
 */
export const TimerThreeIcon = Timer3Icon;
export default TimerThreeIcon